/* global vizData, vizLeagueData, onlyOneCatcher, serverParams */

/* eslint-disable import/no-relative-packages */
/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
/* eslint-disable import/prefer-default-export */
import * as d3 from 'd3'
import debounce from 'lodash/debounce'

if (serverParams.type !== 'catcher') {
    return
}

const { guff } = require('bam-node-baseball-savant/utils/guff')

const {
    ZONE_INCHES_UPPER_LIMIT,
    ZONE_INCHES_LIMIT,
} = require('bam-node-baseball-savant/constants/catcher-framing-viz-constants')

const svg = d3.select('#catcher-framing-graph-viz')
const margin = { top: 80, right: 50, bottom: 50, left: 70 }

let boundedWidth
let boundedHeight

if (svg.node()) {
    boundedHeight = Number(svg.node().getAttribute('height'))
}

let width
const height = boundedHeight - margin.top - margin.bottom

let xAxisScale
let yAxisScale

let xAxis
let xAxisLabel
let yAxis
let insideZoneLabel
let outsideZoneLabel

let title
let leagueAvgWrapper
let clipBox

let leftBoxWrapper
let rightBoxWrapper

let isXZoomed = false
let leftIsBetter

const transformedDataMap = {}

const LINE_COLOR = '#3a9098'

const LOWER_LINE_COLOR = d3.schemeTableau10[1]
const UPPER_LINE_COLOR = d3.schemeTableau10[6]
const BKGD_COLOR = '#ffffffbf'

const STARTING_LINE_OPACITY = 0.08
const TICK_OPACITY = 0.2

const INFO_BOX_WIDTH = 240
const INFO_BOX_HEIGHT = 80
const INFO_BOX_X_OFFSET = 50
const SMALL_INFO_BOX_X_OFFSET = 20
const INFO_BOX_Y_OFFSET = 50
const INFO_BOX_CIRCLE_RADIUS = 30
const INSIDE_OUTSIDE_Y_OFFSET = 35

const INSIDE_OUTSIDE_CUTOFF = 750
const TITLE_CUTOFF = 570
const INSIDE_OUTSIDE_NARROW_OFFSET = 175
const INSIDE_OUTSIDE_STANDARD_OFFSET = 250

const TITLE_VERT_OFFSET = -20
const LEAGUE_AVG_HORIZ_OFFSET = 65
const LEAGUE_AVG_VERT_OFFSET = 28
const LEAGUE_AVG_WIDTH = 104
const LEAGUE_AVG_HEIGHT = 22
const LEAGUE_AVG_BOX_X_OFFSET = -52
const LEAGUE_AVG_BOX_Y_OFFSET = -15

const DEFAULT_LINE_WIDTH = 1.5
const CHOSEN_LINE_WIDTH = 3.0

const HOVER_CIRCLE_RADIUS = 4
const HOVER_AVG_RADIUS = 3

let inside_outside_x_offset

const g = svg
    .append('g')
    .attr('transform', `translate(${margin.left},${margin.top})`)

if (vizData.length > 0) {
    setTimeout(() => {
        setScales()
        transformAllData()
        addStaticElements()
        addData()
    }, 200)
}

function transformAllData() {
    vizData.forEach((d) => {
        transformSingleData(d)
    })
    vizLeagueData.forEach((d) => {
        transformSingleData(d)
    })
}

function transformSingleData(d) {
    const numIterations = ZONE_INCHES_UPPER_LIMIT
    const transformedData = []

    for (let i = 0; i <= numIterations + 1; i++) {
        // Positive case
        if (i <= numIterations) {
            const newObj = {
                bucket: i + 0.5,
                strike_pct: d[`pct_bin_${i}`],
            }
            transformedData.push(newObj)
        }

        if (i > 0) {
            const anotherNewObj = {
                bucket: i * -1 + 0.5,
                strike_pct: d[`pct_bin_minus${i}`],
            }
            transformedData.push(anotherNewObj)
        }
    }

    transformedData.sort((a, b) => Number(a.bucket) - Number(b.bucket))
    transformedDataMap[Number(d.id)] = transformedData
}

function setScales() {
    boundedWidth = svg.node().getBoundingClientRect().width
    width = boundedWidth - margin.left - margin.right

    inside_outside_x_offset =
        boundedWidth < INSIDE_OUTSIDE_CUTOFF
            ? INSIDE_OUTSIDE_NARROW_OFFSET
            : INSIDE_OUTSIDE_STANDARD_OFFSET
    const domainNum = isXZoomed ? ZONE_INCHES_LIMIT : ZONE_INCHES_UPPER_LIMIT

    xAxisScale = d3
        .scaleLinear()
        .domain([domainNum * -1 - 0.5, domainNum + 0.5])
        .range([0, width])
    yAxisScale = d3.scaleLinear().domain([0, 1]).range([height, 0])
}

function getTitleYears() {
    if (serverParams.seasonStart === serverParams.seasonEnd) {
        return `(${serverParams.seasonStart})`
    }
    return `(${serverParams.seasonStart}-${serverParams.seasonEnd
        .toString()
        .slice(-2)})`
}

function getInfoBoxTranslateStrings() {
    const xOffset =
        boundedWidth < TITLE_CUTOFF
            ? SMALL_INFO_BOX_X_OFFSET
            : INFO_BOX_X_OFFSET

    const isNarrow = boundedWidth < INSIDE_OUTSIDE_CUTOFF
    const ratio = boundedWidth / INSIDE_OUTSIDE_CUTOFF

    let rightXInitial = width - INFO_BOX_WIDTH - xOffset
    const rightXAdjustment = (1 - ratio) * INFO_BOX_WIDTH

    if (isNarrow) {
        rightXInitial += rightXAdjustment
    }

    let leftTransformString = `translate(${xOffset},${
        height - INFO_BOX_Y_OFFSET - INFO_BOX_HEIGHT
    })`

    let rightTransformString = `translate(${rightXInitial}, ${INFO_BOX_Y_OFFSET})`

    if (isNarrow) {
        leftTransformString += ` scale(${ratio})`
        rightTransformString += ` scale(${ratio})`
    }

    return [leftTransformString, rightTransformString]
}

function formatXAxis() {
    const numXElems = isXZoomed ? ZONE_INCHES_LIMIT : ZONE_INCHES_UPPER_LIMIT
    return d3
        .axisBottom(xAxisScale)
        .ticks(2 * numXElems + 1)
        .tickSize(-height)
        .tickPadding(10)
        .tickFormat((d) => `${d} "`)
}

function formatXZoneBorder() {
    d3.selectAll('.x-axis-elems .tick line')
        .filter((d) => d === 0)
        .attr('opacity', 1.0)
        .attr('stroke-opacity', 0.7)
        .attr('stroke-width', 3)
        .attr('stroke', '#2eb774')
        .attr('stroke-dasharray', '3,3')
}

function addStaticElements() {
    clipBox = g
        .append('defs')
        .append('clipPath')
        .attr('id', 'framing-viz-clip')
        .append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', width)
        .attr('height', height)

    // Title
    title = g
        .append('text')
        .attr('class', 'graph-title')
        .attr('transform', `translate(${width / 2} , ${TITLE_VERT_OFFSET})`)
        .attr('font-size', '1.4rem')
        .attr('text-anchor', 'middle')
        .attr('fill', LINE_COLOR)
        .text(
            boundedWidth < TITLE_CUTOFF
                ? `CS% vs. In. from Zone Border ${getTitleYears()}`
                : `Called Strike Rate vs. Proximity to Strike Zone Border ${getTitleYears()}`
        )

    // X axis
    xAxis = g
        .append('g')
        .attr('class', 'x-axis-elems')
        .attr('transform', `translate(0, ${height})`)
        .call(formatXAxis())

    // X axis label
    xAxisLabel = g
        .append('text')
        .attr('id', 'xLabel')
        .attr('transform', `translate(${width / 2} , ${height + 35})`)
        .style('text-anchor', 'middle')
        .style('font-size', '1rem')
        .text('Inches from Border of Strike Zone')

    insideZoneLabel = g
        .append('text')
        .attr('id', 'xLabelInside')
        .attr(
            'transform',
            `translate(${width / 2 - inside_outside_x_offset} , ${
                height + INSIDE_OUTSIDE_Y_OFFSET
            })`
        )
        .style('text-anchor', 'middle')
        .style('font-size', '0.9rem')
        .text(
            boundedWidth < INSIDE_OUTSIDE_CUTOFF
                ? '← In'
                : '← Inside Strike Zone'
        )
        .attr('fill', LINE_COLOR)

    outsideZoneLabel = g
        .append('text')
        .attr('id', 'xLabelOutside')
        .attr(
            'transform',
            `translate(${width / 2 + inside_outside_x_offset} , ${
                height + INSIDE_OUTSIDE_Y_OFFSET
            })`
        )
        .style('text-anchor', 'middle')
        .style('font-size', '0.9rem')
        .text(
            boundedWidth < INSIDE_OUTSIDE_CUTOFF
                ? 'Out →'
                : 'Outside Strike Zone →'
        )
        .attr('fill', LINE_COLOR)

    // Y axis
    yAxis = g.append('g').call(
        d3
            .axisLeft(yAxisScale)
            .tickSize(-width)
            .tickFormat((d) => `${(d * 100).toFixed(0)}%`)
    )

    // Y axis label
    g.append('text')
        .attr('id', 'yLabel')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - margin.left / 2)
        .attr('x', 0 - height / 2)
        .attr('dy', '0em')
        .style('text-anchor', 'middle')
        .style('font-size', '1rem')
        .text('Called Strike Percentage')

    d3.selectAll('.tick line')
        .attr('stroke-opacity', TICK_OPACITY)
        .attr('stroke-dasharray', '5,5')

    formatXZoneBorder()

    const [leftTransformString, rightTransformString] =
        getInfoBoxTranslateStrings()

    // Left info box
    if (!onlyOneCatcher) {
        leftBoxWrapper = g
            .append('g')
            .attr('transform', leftTransformString)
            .attr('class', 'viz-box-wrapper-elems')

        leftBoxWrapper
            .append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', INFO_BOX_WIDTH)
            .attr('height', INFO_BOX_HEIGHT)
            .attr('rx', 5)
            .attr('stroke', LOWER_LINE_COLOR)
            .attr('stroke-width', 2)
            .attr('fill', BKGD_COLOR)
    }

    // Right info box
    rightBoxWrapper = g
        .append('g')
        .attr('transform', rightTransformString)
        .attr('class', 'viz-box-wrapper-elems')

    rightBoxWrapper
        .append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', INFO_BOX_WIDTH)
        .attr('height', INFO_BOX_HEIGHT)
        .attr('rx', 5)
        .attr('stroke', UPPER_LINE_COLOR)
        .attr('stroke-width', 2)
        .attr('fill', BKGD_COLOR)

    leagueAvgWrapper = g
        .append('g')
        .attr('class', 'avg-label')
        .attr(
            'transform',
            `translate(${
                width - LEAGUE_AVG_HORIZ_OFFSET
            }, ${LEAGUE_AVG_VERT_OFFSET})`
        )

    leagueAvgWrapper
        .append('rect')
        .attr('x', LEAGUE_AVG_BOX_X_OFFSET)
        .attr('y', LEAGUE_AVG_BOX_Y_OFFSET)
        .attr('width', LEAGUE_AVG_WIDTH)
        .attr('height', LEAGUE_AVG_HEIGHT)
        .attr('rx', 2)
        .attr('stroke', 'black')
        .attr('stroke-width', 2)
        .attr('fill', BKGD_COLOR)

    leagueAvgWrapper
        .append('text')
        .attr('font-size', '0.8rem')
        .attr('text-anchor', 'middle')
        .attr('fill', 'red')
        .attr('font-weight', 'bold')
        .text('---  League Avg.')
}

function addData() {
    const line = d3
        .line()
        .x((d) => xAxisScale(Number(d.bucket)))
        .y((d) => yAxisScale(Number(d.strike_pct)))

    g.selectAll('path.catcher-framing-viz-data')
        .data(vizData)
        .join(
            (enter) => {
                enter
                    .append('path')
                    .attr('class', 'catcher-framing-viz-data')
                    .attr('id', (d) => `catcher_framing_viz_data_${d.id}`)
                    .attr('fill', 'none')
                    .attr('stroke', LINE_COLOR)
                    .attr('stroke-width', DEFAULT_LINE_WIDTH)
                    .attr('opacity', STARTING_LINE_OPACITY)
                    .attr('d', (d) => line(transformedDataMap[Number(d.id)]))
                    .attr('clip-path', 'url(#framing-viz-clip)')
            },
            (update) => {
                update
                    .transition()
                    .attr('d', (d) => line(transformedDataMap[Number(d.id)]))
            }
        )

    g.selectAll('path.catcher-framing-viz-league-data')
        .data(vizLeagueData)
        .join(
            (enter) => {
                enter
                    .append('path')
                    .attr('class', 'catcher-framing-viz-league-data')
                    .attr(
                        'id',
                        (d) => `catcher_framing_viz_league_data_${d.id}`
                    )
                    .attr('fill', 'none')
                    .attr('stroke', 'red')
                    .attr('stroke-width', CHOSEN_LINE_WIDTH)
                    .attr('stroke-dasharray', '5,5')
                    .attr('opacity', 1.0)
                    .attr('d', (d) => line(transformedDataMap[Number(d.id)]))
                    .attr('clip-path', 'url(#framing-viz-clip)')
            },
            (update) => {
                update
                    .transition()
                    .attr('d', (d) => line(transformedDataMap[Number(d.id)]))
            }
        )
}

export function toggleXAxis() {
    const line = d3
        .line()
        .x((d) => xAxisScale(Number(d.bucket)))
        .y((d) => yAxisScale(Number(d.strike_pct)))

    isXZoomed = !isXZoomed

    setScales()
    xAxis.transition().call(formatXAxis())

    d3.selectAll('path.catcher-framing-viz-data')
        .transition()
        .attr('d', (d) => line(transformedDataMap[Number(d.id)]))

    d3.selectAll('path.catcher-framing-viz-league-data')
        .transition()
        .attr('d', (d) => line(transformedDataMap[Number(d.id)]))

    d3.selectAll('.tick line')
        .attr('stroke-opacity', TICK_OPACITY)
        .attr('stroke-dasharray', '5,5')

    formatXZoneBorder()
}

export function highlightChosenPlayers(leftID, rightID) {
    const leftData = vizData.find((d) => d.id === Number(leftID))
    const rightData = vizData.find((d) => d.id === Number(rightID))

    d3.selectAll('.catcher-framing-viz-data')
        .attr('opacity', STARTING_LINE_OPACITY)
        .attr('stroke', LINE_COLOR)
        .attr('stroke-width', DEFAULT_LINE_WIDTH)

    const leftLineElem = d3
        .select(`#catcher_framing_viz_data_${leftID}`)
        .attr('opacity', 1.0)
        .attr('stroke-width', CHOSEN_LINE_WIDTH)
    const rightLineElem = d3
        .select(`#catcher_framing_viz_data_${rightID}`)
        .attr('opacity', 1.0)
        .attr('stroke-width', CHOSEN_LINE_WIDTH)

    leftIsBetter = findHigherLine(leftData, rightData)

    leftLineElem
        .attr('stroke', leftIsBetter ? UPPER_LINE_COLOR : LOWER_LINE_COLOR)
        .raise()
    rightLineElem
        .attr('stroke', leftIsBetter ? LOWER_LINE_COLOR : UPPER_LINE_COLOR)
        .raise()

    if (leftIsBetter) {
        fillInfoBoxes(rightData, leftData)
    } else {
        fillInfoBoxes(leftData, rightData)
    }
}

function findHigherLine(leftData, rightData) {
    let accum = 0

    for (let i = 0; i <= ZONE_INCHES_LIMIT; i++) {
        const leftPct = leftData[`pct_bin_${i}`]
        const rightPct = rightData[`pct_bin_${i}`]

        if (leftPct > rightPct) {
            accum += 1
        }

        if (i > 0) {
            const leftNegPct = leftData[`pct_bin_minus${i}`]
            const rightNegPct = rightData[`pct_bin_minus${i}`]

            if (leftNegPct > rightNegPct) {
                accum += 1
            }
        }
    }

    return accum > ZONE_INCHES_LIMIT
}

function fillInfoBoxes(leftData, rightData) {
    d3.selectAll('.box-player-info').remove()

    if (!onlyOneCatcher) {
        appendInfo(leftBoxWrapper, leftData)
    }
    appendInfo(rightBoxWrapper, rightData)
}

function appendInfo(wrapper, boxData) {
    const thisColor =
        wrapper === leftBoxWrapper ? LOWER_LINE_COLOR : UPPER_LINE_COLOR

    wrapper
        .append('circle')
        .attr('cx', 10 + INFO_BOX_CIRCLE_RADIUS)
        .attr('cy', 10 + INFO_BOX_CIRCLE_RADIUS)
        .attr('r', INFO_BOX_CIRCLE_RADIUS)
        .attr('stroke', thisColor)
        .attr('stroke-width', 2)
        .attr('fill', thisColor)
        .attr('class', 'box-player-info')

    wrapper
        .append('image')
        .attr('x', 10)
        .attr('y', 10)
        .attr('width', INFO_BOX_CIRCLE_RADIUS * 2)
        .attr('height', INFO_BOX_CIRCLE_RADIUS * 2)
        .attr(
            'href',
            `https://midfield.mlbstatic.com/v1/people/${boxData.id}/mlb/80?circle=true`
        )
        .attr('class', 'box-player-info')

    wrapper
        .append('text')
        .attr('x', 80)
        .attr('y', 10)
        .attr('font-size', '18px')
        .attr('fill', thisColor)
        .attr('dominant-baseline', 'hanging')
        .text(boxData.name)
        .attr('class', 'box-player-info')

    const cspText = wrapper
        .append('text')
        .attr('x', 80)
        .attr('y', 35)
        .attr('font-size', '14px')
        .attr('fill', thisColor)
        .attr('dominant-baseline', 'hanging')
        .text('Shadow Strike %: ')
        .attr('class', 'box-player-info')

    const frText = wrapper
        .append('text')
        .attr('x', 80)
        .attr('y', 54)
        .attr('font-size', '14px')
        .attr('fill', thisColor)
        .attr('dominant-baseline', 'hanging')
        .text('Framing Runs: ')
        .attr('class', 'box-player-info')

    const cspLength = cspText.node().getComputedTextLength()
    const frLength = frText.node().getComputedTextLength()

    wrapper
        .append('text')
        .attr('x', 85 + cspLength)
        .attr('y', 35)
        .attr('font-size', '14px')
        .attr('fill', 'black')
        .attr('dominant-baseline', 'hanging')
        .text(guff(boxData.pct_tot, 'cs_percent'))
        .attr('class', 'box-player-info')

    wrapper
        .append('text')
        .attr('x', 85 + frLength)
        .attr('y', 54)
        .attr('font-size', '14px')
        .attr('fill', 'black')
        .attr('dominant-baseline', 'hanging')
        .text(guff(boxData.rv_tot, 'run_value'))
        .attr('class', 'box-player-info')
}

function rescaleElements() {
    const line = d3
        .line()
        .x((d) => xAxisScale(Number(d.bucket)))
        .y((d) => yAxisScale(Number(d.strike_pct)))

    clipBox.attr('width', width).attr('height', height)

    title
        .transition()
        .attr('transform', `translate(${width / 2} , ${TITLE_VERT_OFFSET})`)
        .text(
            boundedWidth < TITLE_CUTOFF
                ? `CS% vs. In. from Zone Border ${getTitleYears()}`
                : `Called Strike Rate vs. Proximity to Strike Zone Border ${getTitleYears()}`
        )

    leagueAvgWrapper
        .transition()
        .attr(
            'transform',
            `translate(${
                width - LEAGUE_AVG_HORIZ_OFFSET
            }, ${LEAGUE_AVG_VERT_OFFSET})`
        )

    xAxis
        .transition()
        .attr('transform', `translate(0, ${height})`)
        .call(formatXAxis())
    xAxisLabel
        .transition()
        .attr('transform', `translate(${width / 2} , ${height + 35})`)

    yAxis.transition().call(
        d3
            .axisLeft(yAxisScale)
            .tickSize(-width)
            .tickFormat((d) => `${(d * 100).toFixed(0)}%`)
    )

    d3.selectAll('path.catcher-framing-viz-data')
        .transition()
        .attr('d', (d) => line(transformedDataMap[Number(d.id)]))

    d3.selectAll('path.catcher-framing-viz-league-data')
        .transition()
        .attr('d', (d) => line(transformedDataMap[Number(d.id)]))

    const [leftTransformString, rightTransformString] =
        getInfoBoxTranslateStrings()

    if (boundedWidth < INSIDE_OUTSIDE_CUTOFF) {
        insideZoneLabel.text('← In')
        outsideZoneLabel.text('Out →')
        inside_outside_x_offset = INSIDE_OUTSIDE_NARROW_OFFSET
    } else {
        insideZoneLabel.text('← Inside Strike Zone')
        outsideZoneLabel.text('Outside Strike Zone →')
        inside_outside_x_offset = INSIDE_OUTSIDE_STANDARD_OFFSET
    }

    if (!onlyOneCatcher) {
        leftBoxWrapper.transition().attr('transform', leftTransformString)
    }
    rightBoxWrapper.transition().attr('transform', rightTransformString)

    insideZoneLabel
        .transition()
        .attr(
            'transform',
            `translate(${width / 2 - inside_outside_x_offset} , ${
                height + INSIDE_OUTSIDE_Y_OFFSET
            })`
        )

    outsideZoneLabel
        .transition()
        .attr(
            'transform',
            `translate(${width / 2 + inside_outside_x_offset} , ${
                height + INSIDE_OUTSIDE_Y_OFFSET
            })`
        )
}

export function highlightVals(bucketNum, leftPlayer, rightPlayer) {
    const leftData = transformedDataMap[leftPlayer]
    const rightData = transformedDataMap[rightPlayer]
    const lgData = transformedDataMap[999999]

    const xVal = xAxisScale(bucketNum)
    const yValLeft = yAxisScale(
        leftData.find((d) => Number(d.bucket) === bucketNum).strike_pct
    )
    const yValRight = yAxisScale(
        rightData.find((d) => Number(d.bucket) === bucketNum).strike_pct
    )
    const yValLeague = yAxisScale(
        lgData.find((d) => Number(d.bucket) === bucketNum).strike_pct
    )

    const leftColor = leftIsBetter ? UPPER_LINE_COLOR : LOWER_LINE_COLOR
    const rightColor = leftIsBetter ? LOWER_LINE_COLOR : UPPER_LINE_COLOR

    g.append('circle')
        .attr('cx', xVal)
        .attr('cy', yValLeague)
        .attr('r', HOVER_AVG_RADIUS)
        .attr('stroke', 'red')
        .attr('fill', 'red')
        .attr('class', 'hover-highlight-elem')

    g.append('line')
        .attr('x1', isXZoomed ? xAxisScale(-3.5) : xAxisScale(-9.5))
        .attr('x2', xVal)
        .attr('y1', yValLeague)
        .attr('y2', yValLeague)
        .attr('stroke', 'red')
        .attr('class', 'hover-highlight-elem hover-guide-line')

    g.append('circle')
        .attr('cx', xVal)
        .attr('cy', leftIsBetter ? yValRight : yValLeft)
        .attr('r', HOVER_CIRCLE_RADIUS)
        .attr('stroke', leftIsBetter ? rightColor : leftColor)
        .attr('fill', leftIsBetter ? rightColor : leftColor)
        .attr('class', 'hover-highlight-elem')

    g.append('line')
        .attr('x1', isXZoomed ? xAxisScale(-3.5) : xAxisScale(-9.5))
        .attr('x2', xVal)
        .attr('y1', leftIsBetter ? yValRight : yValLeft)
        .attr('y2', leftIsBetter ? yValRight : yValLeft)
        .attr('stroke', leftIsBetter ? rightColor : leftColor)
        .attr('class', 'hover-highlight-elem hover-guide-line')

    g.append('circle')
        .attr('cx', xVal)
        .attr('cy', leftIsBetter ? yValLeft : yValRight)
        .attr('r', HOVER_CIRCLE_RADIUS)
        .attr('stroke', leftIsBetter ? leftColor : rightColor)
        .attr('fill', leftIsBetter ? leftColor : rightColor)
        .attr('class', 'hover-highlight-elem')

    g.append('line')
        .attr('x1', isXZoomed ? xAxisScale(-3.5) : xAxisScale(-9.5))
        .attr('x2', xVal)
        .attr('y1', leftIsBetter ? yValLeft : yValRight)
        .attr('y2', leftIsBetter ? yValLeft : yValRight)
        .attr('stroke', leftIsBetter ? leftColor : rightColor)
        .attr('class', 'hover-highlight-elem hover-guide-line')

    if (!onlyOneCatcher) {
        leftBoxWrapper.raise()
    }
    rightBoxWrapper.raise()
}

export function clearHighlights() {
    d3.selectAll('.hover-highlight-elem').remove()
}

window.addEventListener(
    'resize',
    debounce(() => {
        setScales()
        g.attr('transform', `translate(${margin.left},${margin.top})`)
        rescaleElements()
    }, 300)
)
